import { heicTo } from "heic-to";
import { useEffect, useState } from "react";
import { DocRenderer } from "./DocRenderer";
import { BaseImageRenderer } from "./ImageRenderer";

export const HeicImageRenderer: DocRenderer = ({ documentData }) => {
  const [imageData, setImageData] = useState<Blob>();

  useEffect(() => {
    if (!documentData) return;

    heicTo({
      blob: new Blob([documentData]),
      type: "image/jpg",
      quality: 1,
    })
      .then(setImageData)
      .catch((error) => {});
  }, [documentData]);

  return <BaseImageRenderer imageData={imageData} />;
};
